import * as React from "react";

import { useCustomerSession, useJoinDrawerUserExperience } from "../../Common";

import { useMyBagPresentationModel } from "../providers";

export const MyBagRewardsCallout: React.FunctionComponent = () => {
  const { presentationMyBagOrder } = useMyBagPresentationModel();
  const { isCustomerLoggedIn } = useCustomerSession();

  const {
    handleBeginTheJoinDrawerUserExperience,
    handleBeginTheJoinDrawerUserExperience_startingFromRegister,
  } = useJoinDrawerUserExperience();

  const shouldPresent = React.useMemo(() => {
    return !isCustomerLoggedIn;
  }, [isCustomerLoggedIn]);

  const memberSavings = React.useMemo(() => {
    const memberSavingsRealMoneyValue =
      presentationMyBagOrder?.orderValueByItemsBreakdown
        .memberDiscountPotential || 0;
    if (memberSavingsRealMoneyValue > 0) {
      return (
        <React.Fragment>
          <p className="memberSavings">
            <span className="members-save-">{`Members save `}</span>
            <span className="dollar-sign">{`\$`}</span>
            <span className="memberSavingsRealMoneyValue">
              {`${memberSavingsRealMoneyValue?.toFixed(2)}`}
            </span>
            <span className="on-this-order">{` on this order.`}</span>
          </p>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <p className="memberSavings">
            <span className="members-save-">{`Are you a member? Sign in for faster checkout.`}</span>
          </p>
        </React.Fragment>
      );
    }
  }, [presentationMyBagOrder]);

  if (!shouldPresent) {
    return null;
  }

  return (
    <section className="my-bag-rewards-callout">
      <div className="decoration"></div>

      <img className="rewards-image" alt="REWARDS" />
      {memberSavings}

      <p className="actions">
        <a
          className="sign-in"
          href="javascript:void(0)"
          onClick={handleBeginTheJoinDrawerUserExperience}
        >{`Sign in`}</a>
        <span>{` or `}</span>
        <a
          className="join-for-free"
          href="javascript:void(0)"
          onClick={handleBeginTheJoinDrawerUserExperience_startingFromRegister}
        >{`Join`}</a>
        {(presentationMyBagOrder?.orderValueByItemsBreakdown
          .memberDiscountPotential || 0) > 0 ? (
          <span>{` to apply discount.`}</span>
        ) : null}
      </p>
    </section>
  );
};
